


<div class="row">
  <div class="col-6">
    <h2>Endpoint:</h2>

    <div class="endpoint">
      <strong>Get All Templates</strong>
      <button (click)="getAllTemplate()">GET</button> api/Customers/Templates
    </div>

    <div class="endpoint">
      <strong>Get Library Url:</strong>
      <button (click)="getLibraryUrl()">GET</button> api/Customers/<input id="getLibraryUrl-workSiteId" placeholder="workSiteId" />/Templates/<input id="getLibraryUrl-templateName" placeholder="templateName" />/LibraryUrl
    </div>

    <div class="endpoint">
      <strong>Get Site Url:</strong>
      <button (click)="getSiteUrl()">GET</button> api/Customers/<input id="getSiteUrl-workSiteId" placeholder="workSiteId" />/Site
    </div>

    <div class="endpoint">
      <strong>Get Applied Templates:</strong>
      <button (click)="getAppliedTemplates()">GET</button> api/Customers/<input id="getAppliedTemplates-workSiteId" placeholder="workSiteId" />/Templates
    </div>

    <div class="endpoint">
      <strong>Get Provisioning Status:</strong>
      <button (click)="getProvisioningStatus()">GET</button> api/Customers/<input id="getProvisioningStatus-workSiteId" placeholder="workSiteId" />/ProvisioningStatus
    </div>

    <div class="endpoint">
      <strong>Create Site:</strong>
      <button (click)="createSite()">POST</button> api/Customers/<input id="createSite-workSiteId" placeholder="workSiteId" />/Site
    </div>

    <div class="endpoint">
      <strong>Apply Template:</strong>
      <button (click)="applyTemplate()">POST</button> api/Customers/<input id="applyTemplate-workSiteId" placeholder="workSiteId" />/Templates/<input id="applyTemplate-templateName" placeholder="templateName" />
    </div>



  </div>
  <div class="col-6">
    <h2>Result:</h2>
    <textarea id="output" class="output">{{result}}</textarea>
  </div>
</div>
